module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Partnerss/partners-list/partners-list.component.css
// module id = ./src/app/Partnerss/partners-list/partners-list.component.css
// module chunks = main